import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.scrollToBottom()
    
    // Observe for new messages added to the container
    this.observer = new MutationObserver(() => {
      this.scrollToBottom()
    })
    
    if (this.hasContainerTarget) {
      this.observer.observe(this.containerTarget, { childList: true, subtree: true })
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToBottom() {
    // Scroll the parent container (message-list)
    this.element.scrollTop = this.element.scrollHeight
  }
}
